export const BROWSER_REPORT_ID = 'browser';
